<!-- User logged rank -->
<div *ngIf="userLogged" [ngClass]="{ xSmallScreen: xSmallScreen }">
  <ng-container *ngIf="userRank != null; else userNotRankedTemplate">
    <div class="user-rank-info" (click)="navToActivity(userRank.activity_id)">
      <div class="position-container">
        <img [src]="userRank.user?.avatar_url" alt="" srcset="" />
        <app-position-item
          [userRank]="true"
          [rank]="userRank.rank"></app-position-item>
      </div>
      <p>{{ userRank.user.username }}</p>

      <div class="time-info">
        <span class="chrono">{{ userRank.activity_time | chrono }}</span>
        <span class="date">{{
          userRank.activity_date * 1000 | date: 'dd/MM/YYYY'
        }}</span>
      </div>
    </div>
  </ng-container>

  <ng-template #userNotRankedTemplate>
    <div class="user-rank-info user-not-ranked">
      <div class="position-container">
        <img [src]="userLogged?.avatar_url" alt="" srcset="" />
        <app-position-item [userRank]="false" [rank]="'--'"></app-position-item>
      </div>
      <p translate>watch.content.ranking.not_ranked</p>
    </div>
  </ng-template>
</div>

<!-- USER IN NOT LOGGER (NULL) -->
<div *ngIf="userLogged === null">
  <div class="user-rank-info user-not-ranked">
    <div class="position-container">
      <span class="user-avatar"></span>
      <app-position-item [userRank]="false" [rank]="'--'"></app-position-item>
    </div>
    <p translate>watch.content.ranking.not_logged</p>
  </div>
</div>
